import axios from 'axios';
import getRequestData from "@/helpers/get-request-data";
import getRequestHeaders from "@/helpers/get-request-headers";
import Service from "@/abstracts/service";

class prismPeakService extends Service {
    constructor() {
        super('p00012');
    }

    /**
     * @param {Number} page
     * @param {Number} limit
     * @param {Object} filter
     * @returns {Promise<Object>}
     */
    listDocuments(page = 1, limit = 10, filter) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_DOCUMENT_LIST_DOCUMENT",
                page: page,
                limit: limit,
                filter: filter
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let returnValue = {
                        list: [],
                        total: 0
                    };

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        returnValue = {
                            list: payload.data.list,
                            total: payload.data.total
                        };
                    }

                    resolve(returnValue);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }

    /**
     * @param {String} party
     * @param {String} type
     * @returns {Promise<Object>}
     */
    getDocument(party, type) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_DOCUMENT_GET_DOCUMENT",
                party: party,
                type: type
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let document = {};

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        document = payload.data;
                    }

                    resolve(document);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }

    /**
     * @param {String} party
     * @param {String} type
     * @returns {Promise<Object>}
     */
    createDocument(party, type) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_DOCUMENT_CREATE_DOCUMENT",
                party: party,
                type: type
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let createDocument = {};

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        createDocument = payload.data;
                    }

                    resolve(createDocument);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }

    /**
     * @param {String} party
     * @param {String} type
     * @returns {Promise<Object>}
     */
    deleteDocument(party, type) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_DOCUMENT_DELETE_DOCUMENT",
                party: party,
                type: type
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let deleteDocument = {};

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        deleteDocument = payload.data;
                    }

                    resolve(deleteDocument);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }
}

export default new prismPeakService();